module.exports = __webpack_public_path__ + "img/c++-logo.2c368fda.png";